/*
 * Starter Kit Bundle — fixed 3-pack flavour builder.
 * Adapted from click-and-mix-bundle.js but simplified for a fixed size:
 *   - no pack-size chooser
 *   - no 5/10/20 branches
 *   - no 20-pack horizontal scroll behaviour
 *   - separate localStorage key so it can't interfere with the C&M bundle
 *
 * Uses the same <click-and-mix-bundle> wrapper tag (no customElements.define)
 * so the existing click-and-mix.css rules apply unchanged.
 */
$(document).ready(function () {
  var PACK_SIZE = 3;
  var STORAGE_KEY = "starter_selpack";
  var selpack = [];

  // ----- Responsive layout for the selected-packs panel (mirrors C&M) -----
  function initializeSelectedPacks() {
    if (window.matchMedia("(max-width: 1023px)").matches) {
      $(".selected-packs").prependTo(".click-and-mix-wrapper");
      $(".click-and-mix-section").removeClass("section--divider");
      $(".selected-packs").addClass("section--divider animate");
    } else {
      $(".selected-packs").appendTo(".clicknmix-desktop .click-and-mix-left");
      $(".clicknmix-desktop .click-and-mix-left")
        .find("performance-popup")
        .after($(".selected-packs"));
      $(".click-and-mix-section").addClass("section--divider");
      $(".selected-packs").removeClass("section--divider animate");
      $(".selected-packs").css("top", "");
    }
  }
  initializeSelectedPacks();
  $(window).on("resize", initializeSelectedPacks);

  // ----- Restore previous selection from localStorage -----
  if (localStorage.hasOwnProperty(STORAGE_KEY)) {
    try {
      selpack = JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch (e) {
      selpack = [];
    }
    $(".selected-items-wrapper").find(".selected-item").removeClass("active");
    $(".selected-qty").html("0");
    $(".product-selector-item").removeClass("active");

    for (var i = 0; i < selpack.length; i++) {
      var job = selpack[i];
      $('.selected-qty[data-varid="' + job.id + '"]')
        .parents(".product-selector-item")
        .addClass("active");
      $('.selected-qty[data-varid="' + job.id + '"]').html(Number(job.qty));
    }
    reloadsectiondata();
  }

  // ----- Flavour-card interactions -----
  $(".product-selector-item__add-trigger").click(function () {
    $(this).parents(".product-selector-item").find(".qty-add").click();
  });

  $(".addsingle").click(function () {
    $(this).parents(".product-selector-item").addClass("active");
    $(this).parents(".product-selector-item").find(".selected-qty").html("1");
    reloadsectiondata();
  });

  $(".image-wrapper").click(function () {
    var qty = Number(
      $(this).parents(".product-selector-item").find(".selected-qty").html()
    );
    $(this).parents(".product-selector-item").addClass("active");
    $(this)
      .parents(".product-selector-item")
      .find(".selected-qty")
      .html(qty + 1);
    reloadsectiondata();
  });

  $(".qty-minus").click(function () {
    var qty = Number(
      $(this).parents(".product-selector-item").find(".selected-qty").html()
    );
    if (qty == 1) {
      $(this).parents(".product-selector-item").removeClass("active");
      $(this).parents(".product-selector-item").find(".selected-qty").html("0");
    } else {
      $(this)
        .parents(".product-selector-item")
        .find(".selected-qty")
        .html(qty - 1);
    }
    reloadsectiondata();
  });

  $(".qty-add").click(function () {
    var qty = Number(
      $(this).parents(".product-selector-item").find(".selected-qty").html()
    );
    $(this)
      .parents(".product-selector-item")
      .find(".selected-qty")
      .html(qty + 1);
    reloadsectiondata();
  });

  // ----- Slot-strip interactions (click a filled slot to remove it) -----
  $(".selected-item").click(function () {
    if ($(this).hasClass("active")) {
      var index = $(this).attr("data-index");
      $(this)
        .parents(".selected-item-box")
        .find('.remove-item[data-index="' + index + '"]')
        .click();
    }
  });

  $(".remove-item").click(function () {
    $(this).removeClass("active");
    var varid = $(this).attr("data-varid");
    var $qty = $('.selected-qty[data-varid="' + varid + '"]');
    var qty = Number($qty.parents(".product-selector-item").find(".selected-qty").html());
    if (qty == 1) {
      $qty.parents(".product-selector-item").removeClass("active");
      $qty.parents(".product-selector-item").find(".selected-qty").html("0");
    } else {
      $qty.parents(".product-selector-item").find(".selected-qty").html(qty - 1);
    }
    $(this).removeAttr("data-varid");
    reloadsectiondata();
  });

  // ----- Core: reconcile UI to current selection -----
  function reloadsectiondata() {
    $(".error-msg-bundle").remove();
    $(".selected-items-wrapper").find(".selected-item").removeClass("active");
    $(".remove-item-wrapper").find(".remove-item").removeClass("active");
    $(".remove-item-wrapper").find(".remove-item").removeAttr("data-varid");

    var totalcount = 0;
    var aradded = [];

    $(".selected-qty").each(function () {
      var value = Number($(this).html());
      if (value > 0) {
        aradded.push({ id: $(this).data("varid"), qty: value });

        for (var i = 1; i <= value; i++) {
          var ind = totalcount + 1;
          $('.selected-item[data-index="' + ind + '"]').addClass("active");
          $('.remove-item[data-index="' + ind + '"]').addClass("active");
          $('.selected-item[data-index="' + ind + '"]')
            .find("img")
            .attr(
              "src",
              $(this)
                .parents(".product-selector-item")
                .find(".item-img")
                .attr("src")
            );
          $('.remove-item[data-index="' + ind + '"]').attr(
            "data-varid",
            $(this).data("varid")
          );
          totalcount = totalcount + 1;
        }
      }
    });

    selpack = aradded;
    localStorage.setItem(STORAGE_KEY, JSON.stringify(selpack));

    // Show the remove-buttons row only when at least one slot is filled
    if (totalcount > 0) {
      $(".remove-box-1").css("display", "flex");
    } else {
      $(".remove-box-1").css("display", "none");
    }

    // Counter
    $(".selected-count h1").html(totalcount + " / " + PACK_SIZE);

    // Enable submit only when the pack is full; lock further adds at the cap
    if (totalcount >= PACK_SIZE) {
      $(".product-selector-item:not(.active)")
        .find(".addsingle")
        .css("pointer-events", "none");
      $(".qty-add").css("pointer-events", "none");
      $(".image-wrapper").css("pointer-events", "none");
      $("click-and-mix-bundle .product-form__submit").removeAttr("disabled");
      $("click-and-mix-bundle .checkout-btn").removeAttr("disabled");
    } else {
      $(".product-selector-item").find(".addsingle").css("pointer-events", "auto");
      $(".qty-add").css("pointer-events", "auto");
      $(".image-wrapper").css("pointer-events", "auto");
      $("click-and-mix-bundle .product-form__submit").attr("disabled", true);
      $("click-and-mix-bundle .checkout-btn").attr("disabled", true);
    }

    $(".product-selector-item__add-trigger").css(
      "pointer-events",
      totalcount < PACK_SIZE ? "auto" : "none"
    );
  }

  // ----- Checkout (one-time or subscription) — mirrors C&M -----
  $(".checkout-btn").click(function (e) {
    e.preventDefault();
    e.stopPropagation();
    var id = $(this)
      .parents("product-form-clicknmix")
      .find('input[name="id"]')
      .val();
    var qty = 1;

    if ($(".rc-radio__input:checked").val() == "subscription") {
      var selid = $(this)
        .parents("product-form-clicknmix")
        .find(".input-sellingplan:checked")
        .val();
      var cartlink =
        "/cart/clear?return_to=/cart/add?items[][id]=" +
        id +
        "%26items[][quantity]=" +
        qty +
        "%26items[][selling_plan]=" +
        selid +
        "%26return_to=/checkout";
      window.location.href = cartlink;
    } else {
      window.location.href = "/cart/" + id + ":" + qty;
    }
  });

  // ----- Subscription / one-time radio toggle -----
  $(".rc-radio .rc-radio__input").change(function () {
    $(".rc-radio").removeClass("active");
    if ($(this).val() == "onetime") {
      $(".onetime-radio").addClass("active");
      $(".rc-widget .input-sellingplan").attr("disabled", true);
    } else {
      $(".subscription-radio").addClass("active");
      $(".rc-widget .input-sellingplan").removeAttr("disabled");
    }
  });
});
